import { styled } from 'styled-components';

export const Ul = styled.ul`
  width: 100%;
`;
